import React from 'react';
import {useDispatch} from 'react-redux';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import {AppButton} from '@/components/Button';
import {CONSUMER_PROFILE_LOGOUT_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeProfileTracking from '@/services/analytics/amplitude/amplitudeProfileTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import authService from '@/services/auth/authService';
import subscriptionService from '@/services/pushNotification/subscriptionService';
import {showLoader} from '@/state/slices/loadersSlice';

const ConsumerProfileLogoutButton = ({className}) => {
    const dispatch = useDispatch();

    const onLogoutClick = async () => {
        const LOADER_NAME = 'LOGOUT_LOADER';

        amplitudeProfileTracking.trackLogOutClick();
        googleAnalyticsService.trackLogOutClick();
        dispatch(showLoader(LOADER_NAME));

        await subscriptionService.unsubscribeAndDeleteSubscription();
        authService.logout();
    };

    return (
        <AppButton
            className={className}
            onClick={onLogoutClick}
            secondary
            light
            aria-label={getAriaLabel(CONSUMER_PROFILE_LOGOUT_BUTTON_ARIA_LABEL)}
        >
            <AemEditableText pageName={routePaths.CONSUMER_PROFILE} itemName='logoutButton' />
        </AppButton>
    );
};

export default ConsumerProfileLogoutButton;
